import React from "react";
import "../StoragePages.scss";
import { Page } from "components/core/Page";
import { PAGE_SUB_TYPES } from "@sparefoot/tracking-events";
import { StorageHeader } from "components/storages/Header";
import { STUDENT_STORAGE_DATA } from "components/storages/ContentData/StudentStorageData";
import {
	BorderLine,
	Heading,
	Description,
	SubHeading,
	ListPoint,
	LastSearchBar
} from "components/storages/Common";
import { ScrollToTop } from "components/core/ScrollToTop";
import Container from "components/core/Page/Container";
import { useSelector } from "react-redux";
import usePageViewTracking from "hooks/tracking/usePageViewTracking";

function StudentStoragePage() {
	const baseUrl = useSelector((state) => state?.app?.baseUrl);
	usePageViewTracking(PAGE_SUB_TYPES.COLLEGE_LANDING);
	return (
		<Page
			className="storage-page"
			title="College Storage, Student Discounts, & Unit Rentals | Storage.com"
			description="Storage.com helps college students find budget-friendly 
			storage units close to campus for summer break, study abroad trips, 
			& more."
			canonical={`${baseUrl}/college-student-storage/`}
		>
			<Container>
				<StorageHeader
					heading="Find College Storage Near You!"
					level="1"
				/>
				<div className="all-sections">
					{STUDENT_STORAGE_DATA?.map((item, index) => (
						<>
							<Heading
								content={item.heading}
								level="2"
							/>
							<Description desc={item.description} />

							{item.subHeadings &&
								item.subHeadings.map((subHeading) => (
									<>
										<SubHeading
											title={subHeading.title}
											level={subHeading.level}
										/>

										{subHeading.descLink ? (
											<Description
												descLink={subHeading.descLink}
											/>
										) : (
											<>
												<Description
													desc={subHeading.desc}
												/>
												<Description
													desc={subHeading.desc2}
												/>
											</>
										)}
									</>
								))}
							<ul>
								{item.points &&
									item.points.map((point) => (
										<ListPoint
											title={point.title}
											desc={point.desc}
										/>
									))}
							</ul>
							{index !== STUDENT_STORAGE_DATA.length - 1 && (
								<BorderLine />
							)}
						</>
					))}
					<LastSearchBar />
				</div>
			</Container>
			<ScrollToTop />
		</Page>
	);
}

export default StudentStoragePage;
